export const VALUE_RANGES_KEY = 'valueRanges';
export const DEFAULT_VALUE_RANGES = {};
